module.exports = __webpack_public_path__ + "static/media/22769889_1629542467120938_5661487666150907747_o.7c1bf07b.jpg";